// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Loader2 as RawLoader2 } from "lucide-react";
export const Loader2 = /* @__PURE__ */ createIcon(RawLoader2, "Loader2", 2);
